import React, { useEffect, useRef } from "react";
import { Card, CardContent, Grid } from "@mui/material";
import Chart from "chart.js/auto";
import { CustomChartsTitle } from "./CustomTypography";

const PieChartData = ({ data, t }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    let chartInstance;

    if (chartRef?.current) {
      const ctx = chartRef.current.getContext("2d");

      chartInstance = new Chart(ctx, {
        type: "pie",
        data: data,
        options: {
          plugins: {
            legend: {
              display: false, // Disable legend display
            },
            datalabels: {
              display: true,
              labels: {
                display: false,
              },
              color: "#000",
              font: {
                weight: "bold",
              },
            },
          },
        },
      });
    }

    return () => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    };
  }, [data]);

  return (
    <Card sx={{ width: "100%", height: 200, border: "1px solid #A5A5A5" }}>
      <CardContent>
        <Grid container>
          <Grid item xs={7}>
            {data.title ? (
              <CustomChartsTitle>{data.title}</CustomChartsTitle>
            ) : (
              <CustomChartsTitle>{t("TOTAL FPOS & FARMERS")}</CustomChartsTitle>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <div style={{ width: "80%", marginTop: "20px" }}>
              <canvas ref={chartRef} />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div style={{ marginTop: "50px" }}>
              {/* Render the legend here */}
              <div
                style={{
                  padding: "0px",
                  borderRadius: "5px",
                }}
              >
                {data.labels.map((label, index) => (
                  <div key={index} style={{ marginBottom: "5px" }}>
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        backgroundColor:
                          data.datasets[0].backgroundColor[index],
                        display: "inline-block",
                        marginRight: "5px",
                      }}
                    ></div>
                    <span style={{ fontSize: "13px", fontWeight: 500 }}>
                      {label}{" "}
                    </span>
                    <span style={{ fontSize: "13px", fontWeight: 500 }}>
                      {data.datasets[0].data[index]}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PieChartData;
